"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRouterMap = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

var Layout = function Layout() {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../layout/index"));
  });
};

_vue.default.use(_vueRouter.default);

var constantRouterMap = [{
  path: '/login',
  meta: {
    title: '登录',
    noCache: true
  },
  component: function component(resolve) {
    return require(['@/views/login'], resolve);
  },
  hidden: true
}, {
  path: '/404',
  component: function component(resolve) {
    return require(['@/views/features/404'], resolve);
  },
  hidden: true
}, {
  path: '/401',
  component: function component(resolve) {
    return require(['@/views/features/401'], resolve);
  },
  hidden: true
}, {
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component(resolve) {
      return require(['@/views/features/redirect'], resolve);
    }
  }]
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    component: function component(resolve) {
      return require(['@/views/home'], resolve);
    },
    name: 'Dashboard',
    meta: {
      title: '首页',
      icon: 'index',
      affix: true,
      noCache: true
    }
  }]
}, // 系统管理（完整菜单，全部真实页面）
{
  path: '/system',
  component: Layout,
  redirect: '/system/user',
  name: 'System',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  hidden: true,
  children: [{
    path: 'user',
    name: 'User',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/user/index'));
      });
    },
    meta: {
      title: '用户管理',
      icon: 'user',
      noCache: true
    }
  }, {
    path: 'role',
    name: 'Role',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/role/index'));
      });
    },
    meta: {
      title: '角色管理',
      icon: 'peoples',
      noCache: true
    }
  }, {
    path: 'menu',
    name: 'Menu',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/menu/index'));
      });
    },
    meta: {
      title: '菜单管理',
      icon: 'list',
      noCache: true
    }
  }, {
    path: 'dept',
    name: 'Dept',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/dept/index'));
      });
    },
    meta: {
      title: '部门管理',
      icon: 'tree',
      noCache: true
    }
  }, {
    path: 'job',
    name: 'Job',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/job/index'));
      });
    },
    meta: {
      title: '岗位管理',
      icon: 'people',
      noCache: true
    }
  }, {
    path: 'dict',
    name: 'Dict',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/dict/index'));
      });
    },
    meta: {
      title: '字典管理',
      icon: 'education',
      noCache: true
    }
  }, {
    path: 'timing',
    name: 'Timing',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/timing/index'));
      });
    },
    meta: {
      title: '任务调度',
      icon: 'time',
      noCache: true
    }
  }, {
    path: 'userLists',
    name: 'UserLists',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/userLists/index'));
      });
    },
    meta: {
      title: '列表分配',
      icon: 'tree-table',
      noCache: true
    }
  }]
}, // 订单管理
{
  path: '/orders',
  component: Layout,
  redirect: '/order/cms/orders',
  name: 'Orders',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/cms/orders/index'], resolve);
    },
    name: 'OrderList',
    hidden: true,
    meta: {
      title: '合同订单'
    }
  }, {
    path: 'create',
    component: function component(resolve) {
      return require(['@/views/cms/orders/create'], resolve);
    },
    name: 'OrderCreate',
    hidden: true,
    meta: {
      title: '合同方案'
    }
  }]
}, // 客户管理
{
  path: '/customers',
  component: Layout,
  redirect: '/order/cms/customers',
  name: 'Customers',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/cms/customers/index'], resolve);
    },
    name: 'CustomerList',
    hidden: true,
    meta: {
      title: '客户信息管理'
    }
  }]
}, // 改补管理
{
  path: '/modifySupplement',
  component: Layout,
  redirect: '/modifySupplement/index',
  name: 'ModifySupplement',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/index'], resolve);
    },
    name: 'ModifySupplementIndex',
    hidden: true,
    meta: {
      title: '改补管理'
    }
  }, {
    path: 'contractUserShop',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/contractUserShop'], resolve);
    },
    name: 'ModifySupplementShop',
    hidden: true,
    meta: {
      title: '改补门店管理'
    }
  }]
}, // 发货列表
{
  path: '/delivery',
  component: Layout,
  redirect: '/delivery/index',
  name: 'Delivery',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/cms/delivery/index'], resolve);
    },
    name: 'DeliveryList',
    hidden: true,
    meta: {
      title: '发货列表'
    }
  }]
}, // 安装管理
{
  path: '/install',
  component: Layout,
  redirect: '/install/index',
  name: 'Install',
  hidden: true,
  children: [{
    path: 'index',
    component: function component(resolve) {
      return require(['@/views/cms/install/index'], resolve);
    },
    name: 'InstallList',
    hidden: true,
    meta: {
      title: '安装管理'
    }
  }]
}, {
  path: '/user',
  component: Layout,
  hidden: true,
  redirect: 'noredirect',
  children: [{
    path: 'center',
    component: function component(resolve) {
      return require(['@/views/system/user/center'], resolve);
    },
    name: '个人中心',
    meta: {
      title: '个人中心'
    }
  }]
}, {
  path: '/',
  component: Layout,
  hidden: true,
  redirect: '/system',
  children: [{
    path: 'system/user',
    component: function component(resolve) {
      return require(['@/views/system/user'], resolve);
    },
    name: 'SystemUserPage',
    meta: {
      title: '用户列表',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/role',
    component: function component(resolve) {
      return require(['@/views/system/role'], resolve);
    },
    name: 'SystemRolePage',
    meta: {
      title: '角色管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/menu',
    component: function component(resolve) {
      return require(['@/views/system/menu'], resolve);
    },
    name: 'SystemMenuPage',
    meta: {
      title: '菜单管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/dept',
    component: function component(resolve) {
      return require(['@/views/system/dept'], resolve);
    },
    name: 'SystemDeptPage',
    meta: {
      title: '部门管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/job',
    component: function component(resolve) {
      return require(['@/views/system/job'], resolve);
    },
    name: 'SystemJobPage',
    meta: {
      title: '岗位管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/dict',
    component: function component(resolve) {
      return require(['@/views/system/dict'], resolve);
    },
    name: 'SystemDictPage',
    meta: {
      title: '字典管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/userLists',
    component: function component(resolve) {
      return require(['@/views/system/userLists'], resolve);
    },
    name: 'SystemUserListsPage',
    meta: {
      title: '列表分配',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'system/timing',
    component: function component(resolve) {
      return require(['@/views/system/timing'], resolve);
    },
    name: 'SystemTimingPage',
    meta: {
      title: '任务调配',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }]
}, {
  path: '/',
  component: Layout,
  hidden: true,
  redirect: '/cms/cmsDispatchOrder',
  children: [{
    path: 'cms/cmsGenerateReport/subReport/:id(\\d+)',
    component: function component(resolve) {
      return require(['@/views/cms/cmsGenerateReport/subReport'], resolve);
    },
    name: 'subReport',
    meta: {
      title: '子报表',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/cmsGenerateReport/secondSubReport/:id(\\d+)',
    component: function component(resolve) {
      return require(['@/views/cms/cmsGenerateReport/secondSubReport'], resolve);
    },
    name: 'secondSubReport',
    meta: {
      title: '第二个子报表',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/cmsGenerateReport/report',
    component: function component(resolve) {
      return require(['@/views/cms/cmsGenerateReport/report'], resolve);
    },
    name: 'report',
    meta: {
      title: '报表',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/modifySupplement',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/index'], resolve);
    },
    name: 'ModifySupplementList',
    meta: {
      title: '改补管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/modifySupplement/create',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/create'], resolve);
    },
    name: 'ModifySupplementCreate',
    meta: {
      title: '发起改补',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/modifySupplement/edit',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/edit'], resolve);
    },
    name: 'ModifySupplementEdit',
    meta: {
      title: '编辑改补',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }, {
    path: 'cms/modifySupplement/detail',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/edit'], resolve);
    },
    name: 'ModifySupplementDetail',
    meta: {
      title: '查看改补详情',
      icon: 'index',
      affix: false,
      noCache: true
    }
  }, {
    path: 'cms/modifySupplement/contractUserShop',
    component: function component(resolve) {
      return require(['@/views/cms/modifySupplement/contractUserShop'], resolve);
    },
    name: 'ContractUserShopList',
    meta: {
      title: '改补门店管理',
      icon: 'index',
      affix: false,
      noCache: false
    }
  }]
}];
exports.constantRouterMap = constantRouterMap;

var _default = new _vueRouter.default({
  mode: 'hash',
  // mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
});

exports.default = _default;